import React, { useEffect, useState } from "react";
import { db } from "./firebaseConfig";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";

function App() {
  const [sellers, setSellers] = useState([]);

  useEffect(() => {
    const fetchSellers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "sellers"));
        const sellersData = [];

        for (const sellerDoc of querySnapshot.docs) {
          const sellerData = sellerDoc.data();
          sellerData.id = sellerDoc.id;

          // Récupérer la sous-collection "products" pour chaque restaurant
          const productsSnapshot = await getDocs(collection(db, `sellers/${sellerDoc.id}/products`));
          sellerData.products = productsSnapshot.docs.map(productDoc => ({
            id: productDoc.id,
            ...productDoc.data()
          }));

          sellersData.push(sellerData);
        }

        setSellers(sellersData);
      } catch (error) {
        console.error("Erreur lors de la récupération des restaurants:", error);
      }
    };

    fetchSellers();
  }, []);

  return (
    <div>
      <h1>Liste des Restaurants</h1>
      <ul>
        {sellers.length > 0 ? (
          sellers.map((seller) => (
            <li key={seller.id}>
              <strong>Adresse:</strong> {seller.address} <br />
              <strong>Image:</strong> <br />
              <img src={seller.image || "https://via.placeholder.com/150"} alt={seller.address} width="150" />
              <br />
              <strong>Menu:</strong>
              <ul>
                {seller.products.length > 0 ? (
                  seller.products.map((product) => (
                    <li key={product.id}>
                      {product.name} - {product.price} €
                    </li>
                  ))
                ) : (
                  <li>Aucun produit disponible</li>
                )}
              </ul>
            </li>
          ))
        ) : (
          <p>Aucun restaurant trouvé.</p>
        )}
      </ul>
    </div>
  );
}

export default App;
